var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllStablecoinImg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 220,
    viewBox: "0 0 310 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_944_244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 310,
    height: 220
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 220,
    rx: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_944_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2198 138.844L57.2545 55.1377L190.025 170.009L49.2198 138.844Z",
    fill: "url(#paint0_linear_944_244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2545 55.1377L145.348 48.4815L190.025 170.009L57.2545 55.1377Z",
    fill: "url(#paint1_linear_944_244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.713 89.6561L265.839 94.1797L201.167 168.929L218.713 89.6561Z",
    fill: "url(#paint2_linear_944_244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.839 94.1794L269.587 143.776L201.167 168.929L265.839 94.1794Z",
    fill: "url(#paint3_linear_944_244)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_244",
    x1: 76.7864,
    y1: 193.728,
    x2: 131.897,
    y2: 98.2733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D591FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_944_244",
    x1: 106.059,
    y1: 45.351,
    x2: 126.791,
    y2: 177.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_944_244",
    x1: 247.7,
    y1: 108.003,
    x2: 176.475,
    y2: 116.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_944_244",
    x1: 207.604,
    y1: 116.602,
    x2: 265.839,
    y2: 150.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D591FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStablecoinImg01);
export default __webpack_public_path__ + "static/media/allStablecoin_img_01.3e42c1a27f194975f529a39de839539c.svg";
export { ForwardRef as ReactComponent };